<template>
	<Panel :title="title" :icon="icon">
		<div class="panel-block">
			<div class="container">
				<div class="columns is-mobile is-multiline">
					<div class="column stat bright is-6 bbottom">
						<font-awesome-icon class="statIcon" icon="file-alt"/>
						<div class="statInfo">
							<span class="statValue">{{ quiniela.nombre }}</span>
							<span class="statName">Nombre</span>
						</div>
					</div>
					<div class="column stat is-6 bbottom">
						<font-awesome-icon class="statIcon" icon="users"/>
						<div class="statInfo">
							<span class="statValue">{{ quiniela.tipo == 1 ?  'Amigos':'Parlay' }}</span>
							<span class="statName">Rival</span>
						</div>
					</div>

					<div class="column stat bright is-6 bbottom">
						<font-awesome-icon class="statIcon" icon="user"/>
						<div class="statInfo">
							<span class="statValue" v-if="quiniela.creador">{{ quiniela.creador.name }}</span>
							<span class="statName">Creador</span>
						</div>
					</div>
					<div class="column stat is-6 bbottom">
						<font-awesome-icon class="statIcon" icon="exclamation-circle"/>
						<div class="statInfo">
							<span class="tag is-capitalized" :class="classEstado(quiniela.estado)">{{ quiniela.status }}</span>
							<span class="statName">Estado</span>
						</div>
					</div>

					<div class="column stat bright is-6" :class="{ 'bbottom': quiniela.estado > 2 && this.$route.path.includes('/perfil')}">
						<font-awesome-icon class="statIcon" icon="dollar-sign"/>
						<div class="statInfo">
							<span class="statValue">{{ Number(quiniela.apuesta).toLocaleString() }}</span>
							<span class="statName">Apuesta</span>
						</div>
					</div>
					<div class="column stat is-6" :class="{ 'bbottom': quiniela.estado > 2 && this.$route.path.includes('/perfil')}">
						<font-awesome-icon class="statIcon" icon="money-bill-alt"/>
						<div class="statInfo">
							<span class="statValue">{{ Number(quiniela.a_ganar).toLocaleString() }} pts</span>
							<span class="statName">Premio acumulado</span>
						</div>
					</div>


					<div class="column stat bright is-6 " v-if="quiniela.estado > 2 && this.$route.path.includes('/perfil')">
						<font-awesome-icon class="statIcon" icon="check"/>
						<div class="statInfo">
							<span class="statValue">{{ aciertosUser }}</span>
							<span class="statName">Aciertos</span>
						</div>
					</div>
					<div class="column stat is-6" v-if="quiniela.estado > 2 && this.$route.path.includes('/perfil')">
						<font-awesome-icon class="statIcon" icon="clock"/>
						<div class="statInfo">
							<span class="statValue">{{ $timeago.format(new Date(quiniela.created_at),'es') }}</span>
							<span class="statName">Creada</span>
						</div>
					</div>
				</div>
				<p v-if="quiniela.privada && !this.$route.path.includes('/perfil')" @click.prevent="openMessage" class="has-text-centered quiniela-privada"><span class="icon"><font-awesome-icon class="statIcon" icon="lock"/></span> Esta quiniela es privada</p>
			</div>
		</div>
		<slot></slot>
		<div v-if="!this.$route.path.includes('/perfil')">
			<transition name="bounce" mode="out-in">
			<Message v-if="messageVisible" title="Quinielas Privadas" message="Para unirte a una quiniela privada de Amigos el creador tiene que autorizar tu solicitud" v-on:closebtn="closeMessage" />
			</transition>
		</div>
	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'
	import quiniMixin from '@/mixins/quiniMixin'
	import Message from '@/components/Message'

	export default {
		components: { Panel, Message },
		mixins: [quiniMixin],
		props: {
			quiniela: {
				type: Object,
				required: true
			},
			title:{
				type: String,
				default: 'Información'
			},
			icon:{
				type: String,
				default: 'info-circle'
			},
			jugador: {
				type: Object,
				required: false
			}
		},
		name: 'InfoQuiniela',
		computed: {
			aciertosUser(){
				return this.quiniela.jugadores.find(player => player.id == this.jugador.id).pivot.aciertos
			}
		},
		data() {
			return {
				messageVisible: false
			};
		},
		created(){

		},
		methods:{
			closeMessage(){
				this.messageVisible = false
			},
			openMessage(){
				this.messageVisible = true
			}
		}
	};
</script>

<style lang="css" scoped>
.container{
	overflow: hidden;
}
.statValue{
	font-size: 1em;
}
.stat{
	padding: 0.3em 1em;
}
.quiniela-privada{
	font-size: .8em;
	cursor: pointer;
}
</style>
